export default {"src":"/_next/static/media/1982.61da81fc.svg","height":94,"width":168,"blurWidth":0,"blurHeight":0};